import {Box, makeStyles, Typography} from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import NeighbourhoodCard from '../Cards/NeighbourhoodCard';

const useStyles = makeStyles(theme => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fit, minmax(${theme.typography.pxToRem(200)},1fr))`,
    gap: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

function NeighbourhoodSection({city}) {
  const classes = useStyles();
  const neighbourhoods = useSelector(state => {
    if (city?._id) {
      return state.city.featuredLists.neighbourhood.byCity?.[city?._id];
    }
    return null;
  });
  return (
    <>
      <Box mb={2}>
        <Typography className={classes.title} variant="h5" component="h2">
          Neighbourhood
        </Typography>
      </Box>
      <div className={classes.grid}>
        {!!neighbourhoods?.length &&
          neighbourhoods.map(({_id, name, image}) => (
            <NeighbourhoodCard key={_id} id={_id} name={name} image={image} />
          ))}
        {!neighbourhoods?.length && (
          <>
            <NeighbourhoodCard skeleton />
            <NeighbourhoodCard skeleton />
            <NeighbourhoodCard skeleton />
            <NeighbourhoodCard skeleton />
            <NeighbourhoodCard skeleton />
          </>
        )}
      </div>
    </>
  );
}

NeighbourhoodSection.propTypes = {
  city: PropTypes.shape({_id: PropTypes.string.isRequired, cityName: PropTypes.string.isRequired}),
};

NeighbourhoodSection.defaultProps = {
  city: null,
};

export default NeighbourhoodSection;
